import { Injectable } from '@angular/core';
import { ActionButton, ActionButtonConfigService, GungNotificationService } from 'gung-common';
import { ColmecPartnerAgreement, ColmecPartnerAgreementsService } from './colmec-partner-agreements.service';
import { Observable, of, first, catchError, throwError } from 'rxjs';
import { ColmecModalService } from './colmec-modal.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ColmecPartnerAgreementsActionConfigService implements ActionButtonConfigService<ColmecPartnerAgreement> {
  base = [
    {
      title: 'EDIT_PARTNER_AGREEMENT',
      action: (item: ColmecPartnerAgreement) => {
        this.colmecModalService.openCreateEditPartnerAgreementModal(item).then(
          result => {},
          reject => {}
        );
      }
    },
    {
      title: 'VIEW_AGREEMENT',
      action: (item: ColmecPartnerAgreement) => {
        window.open(`https://cdn2.gung.io/${item.agreementFileS3Uri}`, '_blank');
      }
    }
    // {
    //   title: 'DELETE_AGREEMENT',
    //   action: (item: ColmecPartnerAgreement) => {
    //     //
    //     this.colmecModalService
    //       .openConfirmYesNoModal(undefined, this.translateService.instant('DELETE_PARTNER_AGREEMENT_CONFIRM'), {
    //         size: 'sm'
    //       })
    //       .then(
    //         result => {
    //           if (result) {
    //             this.colmecPartnerAgreementsService
    //               .deletePartnerAgreement(item)
    //               .pipe(first())
    //               .subscribe(res => {
    //                 if (!!res) {
    //                   this.gungNotificationService.notify(
    //                     this.translateService.instant('SUCCESS'),
    //                     this.translateService.instant('DELETE_PARTNER_AGREEMENT_SUCCESS'),
    //                     'success'
    //                   );
    //                 } else {
    //                   this.gungNotificationService.notify(
    //                     this.translateService.instant('ERROR'),
    //                     this.translateService.instant('DELETE_PARTNER_AGREEMENT_ERROR'),
    //                     'error'
    //                   );
    //                 }
    //               });
    //           }
    //         },
    //         reason => {}
    //       );
    //   }
    // }
  ];

  constructor(
    protected colmecModalService: ColmecModalService,
    protected colmecPartnerAgreementsService: ColmecPartnerAgreementsService,
    protected translateService: TranslateService,
    protected gungNotificationService: GungNotificationService
  ) {}

  getButtons(item: ColmecPartnerAgreement): Observable<ActionButton<ColmecPartnerAgreement>[]> {
    return new Observable<ActionButton<ColmecPartnerAgreement>[]>(subscriber => {
      let list = [];

      list.push(...this.base);

      if (item.status !== 'ARCHIVED') {
        list.push(
          {
            title: 'ARCHIVE_AGREEMENT',
            action: (item: ColmecPartnerAgreement) => {
              this.colmecModalService
                .openConfirmYesNoModal(undefined, this.translateService.instant('ARCHIVE_PARTNER_AGREEMENT_CONFIRM'), {
                  size: 'sm'
                })
                .then(
                  result => {
                    if (result) {
                      this.colmecPartnerAgreementsService
                        .archivePartnerAgreement(item)
                        .pipe(first(),
                          catchError((error: HttpErrorResponse, caught) => {
                            this.gungNotificationService.notify(
                              this.translateService.instant('ERROR'),
                              error.error.status + ', ' + error.error.gungMessage || error.error.message,
                              'error'
                            );
                            
                            return throwError(() => error);
                          }
                          ))
                        .subscribe(res => {
                          if (!!res) {
                            this.gungNotificationService.notify(
                              this.translateService.instant('SUCCESS'),
                              this.translateService.instant('ARCHIVE_PARTNER_AGREEMENT_SUCCESS'),
                              'success'
                            );
                          } else {
                            this.gungNotificationService.notify(
                              this.translateService.instant('ERROR'),
                              this.translateService.instant('ARCHIVE_PARTNER_AGREEMENT_ERROR'),
                              'error'
                            );
                          }
                        });
                    }
                  },
                  reason => { }
                );
            }
          }
        )
      } else {
        list.push({
          title: 'RESTORE_AGREEMENT',
          action: (item: ColmecPartnerAgreement) => {
            this.colmecModalService
              .openConfirmYesNoModal(undefined, this.translateService.instant('RESTORE_PARTNER_AGREEMENT_CONFIRM'), {
                size: 'sm'
              })
              .then(
                result => {
                  if (result) {
                    this.colmecPartnerAgreementsService
                      .restorePartnerAgreement(item)
                      .pipe(first(),
                        catchError((error: HttpErrorResponse, caught) => {
                          this.gungNotificationService.notify(
                            this.translateService.instant('ERROR'),
                            error.error.status + ', ' + error.error.gungMessage || error.error.message,
                            'error'
                          );
                              
                          return throwError(() => error);
                        }
                        ))
                      .subscribe(res => {
                        if (!!res) {
                          this.gungNotificationService.notify(
                            this.translateService.instant('SUCCESS'),
                            this.translateService.instant('RESTORE_PARTNER_AGREEMENT_SUCCESS'),
                            'success'
                          );
                        } else {
                          this.gungNotificationService.notify(
                            this.translateService.instant('ERROR'),
                            this.translateService.instant('RESTORE_PARTNER_AGREEMENT_ERROR'),
                            'error'
                          );
                        }
                      });
                  }
                },
                reason => { }
              );
          }
        }
        )
      }
    
      subscriber.next(list);
    });
  }
}
